import { GeneralPropsType } from "@/common/types";
import { Modal, ModalContent, useDisclosure } from "@nextui-org/react";
import clsx from "clsx";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { forwardRef, useEffect, useRef, useState } from "react";
import DynamicSizeIcon from "../DynamicSizeIcon";
import { NAVBAR_ITEMS } from "@/common/const";
import { useGlobalData } from "@/contexts/GlobalData";
import ModalLayout from "../ModalLayout";
import DynamicFontSize from "../DynamicFontSize";
import styles from "./index.module.css";
import Link from "next/link";
export interface BottomNavbarItemProps extends GeneralPropsType {
  path?: string;
  active?: boolean;
  onRouted?: (data?: any) => any;
}
const bufferSpace = 4;
export function BottomNavbarItem({
  path,
  className,
  onRouted,
  active
}: BottomNavbarItemProps) {
  const prefix = "_navbar_";
  const {
    getIcon,
    translate,
    runEffectNavigation,
    languageData,
    userInfo,
    onOpenComingSoon
  } = useGlobalData();
  const router = useRouter();
  const onClickItem = async () => {
    if (path) {
      if (path === "/portfolio" && translate("open_portfolio") != "true") {
        onOpenComingSoon();
        return;
      }
      if (path === "/mission" && !userInfo?.permissions.mission) {
        onOpenComingSoon();
        return;
      }
      router.push(path);
      runEffectNavigation();
    }
  };
  useEffect(() => {
    if (translate("open_portfolio") == "true") {
      router.prefetch("/portfolio");
    }
  }, [languageData]);
  return <>
            {path != "/portfolio" && path != "/mission" && <Link href={path || ""} className={clsx(className)} onClick={runEffectNavigation}>
                    <div className={clsx("flex flex-col gap-0.5 items-center justify-end py-[10px] px-2 cursor-pointer relative")}>
                        {!!path?.slice(1) && <DynamicSizeIcon width={24} icon={getIcon(path?.slice(1) + prefix + "icon" + (active ? "_active" : ""))}></DynamicSizeIcon>}
                        <DynamicFontSize fontSize={9} className={clsx("text-[#D9D9D9] capitalize", {
          "text-secondary": active
        })}>
                            {translate(path?.slice(1))}
                        </DynamicFontSize>
                    </div>
                </Link>}

            {path == "/mission" && <div onClick={onClickItem} className={clsx("flex flex-col gap-0.5 items-center justify-end py-[10px] px-2 cursor-pointer relative", className)}>
                    {!!path?.slice(1) && <DynamicSizeIcon width={24} icon={getIcon(path?.slice(1) + prefix + "icon" + (active ? "_active" : ""))}></DynamicSizeIcon>}
                    <DynamicFontSize fontSize={9} className={clsx("text-[#D9D9D9] capitalize", {
        "text-secondary": active
      })}>
                        {translate(path?.slice(1))}
                    </DynamicFontSize>
                </div>}
            {path == "/portfolio" && <div onClick={onClickItem} className={clsx("flex flex-col gap-0.5 items-center justify-end py-[10px] px-2 cursor-pointer relative", className)}>
                    {!!path?.slice(1) && <DynamicSizeIcon width={24} icon={getIcon(path?.slice(1) + prefix + "icon" + (active ? "_active" : ""))}></DynamicSizeIcon>}
                    <DynamicFontSize fontSize={9} className={clsx("text-[#D9D9D9] capitalize", {
        "text-secondary": active
      })}>
                        {translate(path?.slice(1))}
                    </DynamicFontSize>
                </div>}
        </>;
}
const BottomNavbar = forwardRef<HTMLDivElement, GeneralPropsType>(({
  className
}, ref) => {
  const pathname = usePathname();
  const thisElementRef = useRef<any>();
  const [width, setWidth] = useState(390);
  const [height, setHeight] = useState(70);
  const setSize = () => {
    try {
      if (thisElementRef.current) {
        thisElementRef.current.style.opacity = "0";
      }
      setTimeout(() => {
        const eWidth = thisElementRef.current.clientWidth;
        const eHeight = thisElementRef.current.clientHeight;
        setWidth(eWidth);
        setHeight(eHeight);
        if (thisElementRef.current) {
          thisElementRef.current.style.opacity = "1";
        }
      }, 200);
    } catch (err) {}
  };
  useEffect(() => {
    setSize();
    window.addEventListener("resize", setSize);
    window.addEventListener("orientationchange", setSize);
    return () => {
      window.removeEventListener("resize", setSize);
      window.removeEventListener("orientationchange", setSize);
    };
  }, []);
  const {
    getIcon,
    translate,
    hapticFeedback
  } = useGlobalData();
  const router = useRouter();
  const halfPartWidth = width / 5 * 2 + bufferSpace;
  const circleWidth = width - halfPartWidth * 2 - 2 * bufferSpace;
  return <div className={clsx("w-full max-w-[100vw-32px] ", className)} ref={ref}>
            <div style={{
      clipPath: `path("M${halfPartWidth} 0 A${(width - 2 * halfPartWidth) / 2} ${(width - 2 * halfPartWidth) / 2} 0 0 0 ${width - halfPartWidth} 0 H${width} V${height} H0 V0 Z")`
    }} ref={thisElementRef} className={clsx("w-full flex items-stretch bg-[#414A64] rounded-2xl backdrop-blur-[12px] cursor-pointer")}>
                {NAVBAR_ITEMS.map((item, index) => {
        return <BottomNavbarItem className="w-[20%]" key={item.path} path={item.path} active={pathname == item.path} />;
      })}
            </div>
            <div className={clsx("absolute bg-no-repeat bg-cover bg-center left-1/2  rounded-full -translate-x-1/2  text-base cursor-pointer", {
      "text-description bg-[#414A64]": pathname != "/",
      [styles.bg_gradient_green_blue]: pathname == "/",
      "text-secondary": pathname == "/"
    })} onClick={() => {
      try {
        router.push("/");
        hapticFeedback.impactOccurred("medium");
      } catch (err) {}
    }} style={{
      // backgroundImage: `url(${getIcon("_navbar_icon")})`,
      width: `${circleWidth}px`,
      height: `${circleWidth}px`,
      top: `-${(width - 2 * halfPartWidth) / 2 - bufferSpace / 2}px`
    }}>
                <svg viewBox="0 0 60 26" className={clsx(styles.svg, "absolute inset-0 m-auto select-none")}>
                    <symbol id="s_text">
                        <text className={styles.svg_text} textAnchor="middle" x="50%" y="100%">
                            TBK
                        </text>
                    </symbol>
                    <g className="g-ants">
                        <use href="#s_text" className={styles.text_copy}></use>
                        <use href="#s_text" className={styles.text_copy}></use>
                        <use href="#s_text" className={styles.text_copy}></use>
                        <use href="#s_text" className={styles.text_copy}></use>
                        <use href="#s_text" className={styles.text_copy}></use>
                    </g>
                </svg>
            </div>
        </div>;
});
BottomNavbar.displayName = "BottomNavbar";
export default BottomNavbar;